import { servicesAPI } from "../api"
import { Workspace } from "../../models"
import {
    GDLWorkspaceListResponse,
    WorkspacesGDLResponse,
} from "../models/workspace"

export const getGDLData = (
    datakey: string,
    requestedPageNumber: number,
    filter: Record<string, string | boolean>,
    isPrintView?: boolean,
): Promise<GDLWorkspaceListResponse> =>
    servicesAPI.postJSON(
        "GetGDLData",
        {
            datakey,
            requestedPageNumber,
            filter,
            isPrintView,
        },
        parseWorkspaceListCallback,
    )

export const applyGDLFilter = (
    datakey: string,
    filter: Record<string, string | boolean>,
    currentPath: string | null,
): Promise<GDLWorkspaceListResponse> =>
    servicesAPI.postJSON(
        "ApplyGDLFilter",
        {
            datakey,
            filter,
            currentPath,
        },
        parseWorkspaceListCallback,
    )

const parseWorkspaceListCallback = (
    json: WorkspacesGDLResponse,
): Promise<GDLWorkspaceListResponse> => {
    let currentPage = 0
    let count = 0
    let pageSize = 0
    const workspaces = [] as Workspace[]

    if (!!json.d.Value) {
        const { PageSize, RequestedPage, Rows, TotalNumberOfRows } =
            json.d.Value

        currentPage = RequestedPage
        count = TotalNumberOfRows
        pageSize = PageSize

        Rows.forEach(({ ID, Properties }) => {
            let code = ""
            let isActive = false
            let screenLabel = ""

            Properties.forEach(({ Key, Value }) => {
                if (Key === "Name") {
                    // string field
                    code = Value as string
                } else if (Key === "ScreenLabel") {
                    // string field
                    screenLabel = Value as string
                } else if (Key === "IsActive") {
                    // boolean field
                    isActive = Value as boolean
                }
            })

            workspaces.push({
                code,
                id: ID,
                isActive,
                label: screenLabel,
            })
        })
    }

    return new Promise<GDLWorkspaceListResponse>((resolve) =>
        resolve({
            pagination: {
                currentPage,
                count,
                pageSize,
            },
            workspaces,
        }),
    )
}
